import { render, staticRenderFns } from "./ImportationVariantComponent.vue?vue&type=template&id=37603566&scoped=true"
import script from "./ImportationVariantComponent.vue?vue&type=script&lang=js"
export * from "./ImportationVariantComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37603566",
  null
  
)

export default component.exports